import { Component, OnInit, OnDestroy } from '@angular/core';
import { UiService } from '../../services/ui/ui.service';
import { UserService } from '../../services/user/user.service';
import { HelperService } from '../../services/helper/helper.service';
import { EventService } from '../../services/event/event.service';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _previousSearchTerm = '';

  public userImage: any;
  public searchTerm = '';
  public logo = '../assets/img/logo.png';

  constructor(
    private ui: UiService,
    public user: UserService,
    public helper: HelperService,
    public event: EventService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userImage = localStorage.getItem('imagePath');
    this.event.on('updateProfileImage', () => {
      this.userImage = localStorage.getItem('imagePath');
    });
    this.event.on('updateProfileName', () => {
      this.user.info = JSON.parse(localStorage.getItem('userDetails'));
    });
    this._subscriptions.push(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          // console.log(event.url);
          if (!event.url.includes('search')) {
            this.searchTerm = '';
          }
        }
      }),
      this.router.routerState.root.queryParams.subscribe(
        queryParams => {
          this.searchTerm = queryParams.term || this.searchTerm;
          this._previousSearchTerm = this.searchTerm;
        }
      )
    );
    this.getLogo();
  }

  getLogo() {
    const branchId = this.user.userBranchId;

    this.user.getLogo(branchId, (res) => {
      this.logo = this.user.logoUrl || this.logo;
    });
  }


  ngOnDestroy() {
    this._subscriptions.forEach(S => S.unsubscribe());
  }

  toggleSidebar() {
    this.ui.showSidebar = !this.ui.showSidebar;
  }

  search() {
    if (this._previousSearchTerm === this.searchTerm) { return; }
    this._previousSearchTerm = this.searchTerm;
    if (this.searchTerm) {
      this.router.navigate(['/search'], { queryParams: { term: this.searchTerm } });
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/header/header.component.ts